// extracted by mini-css-extract-plugin
export default {"container":"ButtonDots_container__OcUeh","large":"ButtonDots_large__gNK0O","red-dot":"ButtonDots_red-dot__PCZTf","white-dot":"ButtonDots_white-dot__pKbyb"};